import * as React from 'react'
import { styled, FontWeight } from '$utils/theme'
import { rem } from 'polished'
import checkIcon from '$icons/checkbox.svg'
import { Division } from '../Division'
import { Text } from '../Text'
import { Icon } from '../Icon'
import { Block } from '../Layout/Block'

const innerHtmlCheck = { __html: checkIcon }

interface Props extends React.InputHTMLAttributes<any> {
  className?: string
  label?: string
  onBlur?: any
  isChecked?: (name: string) => boolean
  onClick?: () => void
  onChange?: any
  right?: boolean
  description?: string
  icon?: string
  checked?: boolean
  color?: string
  square?: boolean
  rigthBackground?: boolean
}

const CheckBoxWrapper = styled.label<Props>`
  display: block;
  position: relative;

  padding-left: ${p => !p.right && rem(p.theme.sizes.large)};
  padding-top: ${rem(5)};
  ${p =>
    p.square &&
    `
    padding-left:${rem(p.theme.sizes.medium)};
  `}
  margin-bottom: ${p => rem(p.theme.sizes.mini)};

  ${p => p.theme.font.base(FontWeight.regular)};

  cursor: ${p => (p.disabled ? 'no-drop' : 'pointer')};
  height: ${p => !p.right && rem(p.theme.sizes.medium)};
  color:${p => p.theme.colors.darkGrey};

  ${p =>
    p.icon &&
    `
    height: auto;
    background-color:${p.theme.colors.white}
    margin: 0;
    padding: 0;
    border-top: solid 1px ${p.theme.colors.greyShadow};
  `}
    ${p =>
      p.rigthBackground &&
      `
    height: 80px;
    background-color:${p.theme.colors.white}
    margin: 0;
    padding: 0;
    border-top: solid 1px ${p.theme.colors.greyShadow};
    ${p.checked &&
      `
      background-color:${p.theme.colors.xlightBlue}

    `}
  `}

`

const StyledCheckBox = styled.span.attrs({})<Props>`
  position: absolute;
  //? El 50% del tamaño del elemento menos tamaño del margen del divisor de abajo entre 2
  top: calc(50% - ${p => rem(p.theme.sizes.small)} / 2);
  //? con el translateY para centrar el elemento en vertical
  transform: translateY(-50%);
  ${p => (p.right ? `right:0` : `left:0`)};
  ${p => p.right && `margin-left: ${rem(p.theme.sizes.base)}`};
  ${p =>
    p.icon &&
    `
      top: 0;
      transform: none;
      right: 0;
      left: auto;
      margin: ${rem(28)} ${rem(p.theme.sizes.small)} 0  ${rem(p.theme.sizes.mini)};
  `};

${p =>
  p.rigthBackground &&
  `
      right: 0;
      left: auto;
      margin-right:${rem(p.theme.sizes.small)};
      margin-top:${rem(p.theme.sizes.small)};

  `};

  height: ${p => rem(p.theme.sizes.medium)};
  width: ${p => rem(p.theme.sizes.medium)};

  background: ${p => p.theme.colors.xlightGrey};
  border: solid 1px ${p => p.theme.colors.grey};
  border-radius: ${p => rem(p.theme.sizes.medium)};
  ${p =>
    p.square &&
    `
    height: 20px;
    width: 20px;
    border-radius: 5px;
    top: 3px;
  `}
  padding: ${p => rem(p.theme.sizes.tiny)};

  > svg {
    display: none;
    path {
      fill: ${p => p.theme.colors.white};
    }
  }
`

const InputCheckBox = styled.input.attrs({})<Props>`
  position: absolute;
  opacity: 0;
  top: ${p => rem(p.theme.sizes.none)};
  left: ${p => rem(p.theme.sizes.mini)};
  vertical-align: middle;
  margin-bottom: ${p => rem(p.theme.sizes.small)};
  cursor: ${p => (p.disabled ? 'no-drop' : 'pointer')};

  &:focus {
    outline: none;
  }
  &:checked ~ ${StyledCheckBox} {
    background-color: ${p => p.theme.colors.darkGrey};
    border-color: ${p => p.theme.colors.darkGrey};
    ${p =>
      p.square &&
      `
      border-color: ${p.theme.colors.lightGrey};
    `} svg {
      display: block;
      width: 100%;
      height: 100%;
      use {
        fill: ${p => p.theme.colors.white};
      }
    }
  }
`

const StyledIcon = styled(Icon)`
  margin: 1.5rem 1rem 1.5rem 2rem;
`

const StyledText = styled(Text).attrs({})<Props>`
  font-weight: ${p => p.theme.fontWeight.medium}
    ${p =>
      p.rigthBackground &&
      `
    margin-left:${rem(p.theme.sizes.mini)};
    margin-right:${rem(p.theme.sizes.xlarge)};
  `};
`

const StyledBlockIcon = styled(Block).attrs({})<Props>`
  ${p =>
    p.rigthBackground &&
    `
    height:100%;
  `};
`

export class Checkbox extends React.Component<Props> {
  render() {
    const {
      label,
      name,
      onBlur,
      isChecked,
      onClick,
      onChange,
      id,
      right,
      description,
      icon,
      color,
      square,
      rigthBackground,
      ...props
    } = this.props
    return (
      <CheckBoxWrapper
        {...props}
        htmlFor={id}
        right={right}
        icon={icon}
        checked={isChecked(name)}
        square={square}
        rigthBackground={rigthBackground}
      >
        <StyledBlockIcon flex alignItems="center" rigthBackground={rigthBackground}>
          <Block>{icon && <StyledIcon size="xl" content={icon} color={color} />}</Block>
          <Block>
            <StyledText icon={icon} rigthBackground={rigthBackground}>
              {label}
            </StyledText>
            {!right && description && (
              <Block marginRight="mini">
                <Text color="menu" menu marginRight="xlarge">
                  {description}
                </Text>
              </Block>
            )}
          </Block>
        </StyledBlockIcon>
        <InputCheckBox
          name={name}
          type="checkbox"
          onBlur={onBlur}
          checked={isChecked(name)}
          onClick={onClick}
          onChange={onChange}
          square={square}
          data-testid={id}
          {...{ id, ...props }}
        />
        {right && description && (
          <Text weight="light" color="menu" marginTop="base" marginRight="large">
            {description}
          </Text>
        )}
        {right && <Division color="lightGrey" marginTop="small" marginBottom="small" />}
        <StyledCheckBox
          dangerouslySetInnerHTML={innerHtmlCheck}
          right={right}
          icon={icon}
          square={square}
          rigthBackground={rigthBackground}
        />
      </CheckBoxWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Checkbox/Checkbox.tsx